import { ILocaleConfig } from "@/config/locale.config";
import { SupportedLocale, LocaleToLabelMap } from "@/enums/locale.enum";

// UAE-specific locale configuration
const uaeLocaleConfig: ILocaleConfig = {
  supportedLocales: [
    SupportedLocale.AR,
    SupportedLocale.EN,
    SupportedLocale.RU,
  ],
  defaultLocale: SupportedLocale.EN,
  languageTabs: [
    {
      key: SupportedLocale.AR,
      label: LocaleToLabelMap.get(SupportedLocale.AR)!,
    },
    {
      key: SupportedLocale.EN,
      label: LocaleToLabelMap.get(SupportedLocale.EN)!,
    },
    {
      key: SupportedLocale.RU,
      label: LocaleToLabelMap.get(SupportedLocale.RU)!,
    },
  ],
};

export default uaeLocaleConfig;
